import * as React from "react";
import TablePagination from "@mui/material/TablePagination";

export interface CompactPaginationProps {
	/** Total number of items */
	count: number;
	/** Current page (0-indexed) */
	page: number;
	/** Number of rows per page */
	rowsPerPage: number;
	/** Callback when page changes */
	onPageChange: (event: unknown, newPage: number) => void;
	/** Callback when rows per page changes */
	onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	/** Available page size options */
	rowsPerPageOptions?: number[];
}

export function CompactPagination({
	count,
	page,
	rowsPerPage,
	onPageChange,
	onRowsPerPageChange,
	rowsPerPageOptions = [10, 25, 50, 100],
}: CompactPaginationProps): React.JSX.Element {
	return (
		<TablePagination
			component="div"
			count={count}
			onPageChange={onPageChange}
			onRowsPerPageChange={onRowsPerPageChange}
			page={page}
			rowsPerPage={rowsPerPage}
			rowsPerPageOptions={rowsPerPageOptions}
			showFirstButton
			showLastButton
			sx={{
				".MuiTablePagination-toolbar": {
					minHeight: "52px",
					paddingLeft: 1,
					paddingRight: 1,
				},
				".MuiTablePagination-selectLabel": {
					fontSize: "0.875rem",
				},
				".MuiTablePagination-displayedRows": {
					fontSize: "0.875rem",
				},
			}}
		/>
	);
}
